module.exports = __webpack_public_path__ + "img/ico_vegano.bf92e636.svg";